













import { Component, Vue, namespace } from 'nuxt-property-decorator'
import { INFO_API } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import ComponentNavigationBreadcrumbs from '~/components/navigation/breadcrumbs.vue'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { IMeta } from '~/assets/interfaces/meta'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import { filterUrl } from '~/assets/filters/url'
const pageStore = namespace('page')
@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentNavigationBreadcrumbs,
    ComponentTypographyH1,
  },
})
export default class pageContactsIndex extends Vue {
  private async asyncData({
    $axios,
    route,
    error,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
    error: any
  }) {
    try {
      const response = await $axios.$get(
        filterUrl(INFO_API + '/' + route.params._slug)
      )

      return response
    } catch (err: any) {
      if (err.response.status === 403 || err.response.statusCode === 403) {
        error({ statusCode: 403, message: 'Access denied' })
      } else {
        error({ statusCode: 404, message: 'Post not found' })
      }
    }
  }

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  private meta: IMeta | null = null
  private breadcrumbs: IBreadcrumbsItem[] = []
  private content: string | null = null

  private created(): void {
    if (this.meta) {
      this.setMeta(this.meta)
    }
    if (this.breadcrumbs) {
      this.setBreadcrumbs(this.breadcrumbs)
    }
  }

  private $style!: IStyle
  private styleGrid!: IStyle
  private styleMobileGrid!: IStyle
  private get classWrapper() {
    return {
      [this.$style.wrapper]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private get classPageWrapper() {
    return {
      [this.styleGrid.container]: !this.$device.isMobileOrTablet,
      [this.styleMobileGrid.container]: this.$device.isMobileOrTablet,
      [this.$style.pageWrapper]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }
}
